module.exports = __webpack_public_path__ + "static/media/ico-back.71d12eab.svg";